// @ts-nocheck
/* eslint-disable */
/* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */
import { ReactComponent as LogoAirflow } from '../../../assets/images/Logos/logo-airflow.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoAirflowIcon = /* @__PURE__ */ withLogoClass(LogoAirflow);
